import { render, staticRenderFns } from "./ResearcherCard.vue?vue&type=template&id=532e6765&scoped=true&"
import script from "./ResearcherCard.vue?vue&type=script&lang=js&"
export * from "./ResearcherCard.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherCard.vue?vue&type=style&index=0&id=532e6765&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e6765",
  null
  
)

export default component.exports